import { useState } from 'react'

import { FormAccordionWrapper } from '../FormAccordionWrapper/FormAccordionWrapper'
import { MultiSelect, MultiSelectCommonIProps } from './MultiSelect'

interface FormMultiSelectControlIProps extends MultiSelectCommonIProps {
  label: string
  labelStyle?: React.CSSProperties
}

export const FormMultiSelectControl = ({
  placeholder,
  label,
  options,
  defaultValue,
  control,
  id,
  onSearchChange,
  searchValue,
  isLoading = false,
  labelStyle,
}: FormMultiSelectControlIProps) => {
  const [numberSelected, setNumberSelected] = useState<number>(null)
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <FormAccordionWrapper
      label={label}
      labelStyle={labelStyle}
      numberSelected={numberSelected}
      onAccordionButtonClick={(isExpanded) => setIsExpanded(!isExpanded)}
    >
      <MultiSelect
        control={control}
        defaultValue={defaultValue}
        id={id}
        isExpanded={isExpanded}
        isLoading={isLoading}
        numberSelected={numberSelected}
        onNumberSelectedChange={setNumberSelected}
        onSearchChange={onSearchChange}
        options={options}
        placeholder={placeholder}
        searchValue={searchValue}
      />
    </FormAccordionWrapper>
  )
}
